import type { Component } from "vue"
import { defineAsyncComponent } from "vue"

import NotFoundComponent from "@/Components/CMS/Webpage/NotFoundComponent.vue"
import Header2Iris from "@/Iris/Components/IrisBlocks/Header2Iris.vue"
import Header1Iris from "@/Iris/Components/IrisBlocks/Header1Iris.vue"
import Topbar1FulfilmentIris from "@/Iris/Components/IrisBlocks/Topbar1FulfilmentIris.vue"
import Topbar2FulfilmentIris from "@/Iris/Components/IrisBlocks/Topbar2FulfilmentIris.vue"
import Topbar1Iris from "@/Iris/Components/IrisBlocks/Topbar1Iris.vue"
import Topbar2Iris from "@/Iris/Components/IrisBlocks/Topbar2Iris.vue"
import Menu1Iris from "@/Iris/Components/IrisBlocks/Menu1Iris.vue"
import Footer1Iris from "@/Components/CMS/Website/Footers/footerTheme1/Footer1Iris.vue"
/* import ImageIris from '@/Iris/Components/IrisBlocks/ImageIris.vue'
import TextContentIris from "@/Iris/Components/IrisBlocks/TextContentIris.vue"
import WowsbarBannerIris from "@/Iris/Components/IrisBlocks/WowsbarBannerIris.vue" */
/* import ListProductsEcomIris from "@/Iris/Components/IrisBlocks/Products/Ecom/ListProductsEcomIris.vue" */

const async = (loader: () => Promise<any>): Component =>
	defineAsyncComponent({
		loader,
		delay: 200,
		timeout: 30000,
		onError(_error, retry, fail, attempts) {
			if (attempts >= 3) {
				fail()

				return
			}

			setTimeout(retry, attempts * 1000)
		},
	})

//Department
const DepartmentDescriptionIris = async(() => import("@/Iris/Components/IrisBlocks/DepartmentDescriptionIris.vue"))
const DepartmentDescriptionIris2 = async(() => import("@/Iris/Components/IrisBlocks/DepartmentDescriptionIris2.vue"))
const DepartmentDescriptionIris3 = async(() => import("@/Iris/Components/IrisBlocks/DepartmentDescriptionIris3.vue"))

// Sub-department
const SubDepartmentDescriptionIris = async(() => import("@/Iris/Components/IrisBlocks/SubDepartmentDescriptionIris.vue"))

const ListProductsIris = async(() => import("@/Iris/Components/IrisBlocks/Products/ds/ListProductsIris.vue"))
const ProductRender = async(() => import("@/Iris/Components/IrisBlocks/Products/ds/ProductCardDs/ProductCardDs1.vue"))
const ListProductsEcomIris = async(() => import("@/Iris/Components/IrisBlocks/Products/Ecom/ListProductsEcomIris.vue"))
const ProductIris1 = async(() => import("@/Iris/Components/IrisBlocks/Product/Ds/ProductDsIris1.vue"))
const ProductIris1Ecom = async(() => import("@/Iris/Components/IrisBlocks/Product/Ecom/ProductIris1Ecom.vue"))
const InternalTrends1Iris = async(() => import("@/Iris/Components/IrisBlocks/InternalTrends1Iris.vue"))
const InternalLastSeen1Iris = async(() => import("@/Iris/Components/IrisBlocks/InternalLastSeen1Iris.vue"))
const InternalItemAlternatives1Iris = async(() => import("@/Iris/Components/IrisBlocks/InternalItemAlternatives1Iris.vue"))
const AnnouncementInformation1 = async(() => import("@/Iris/Components/IrisBlocks/Announcement/AnnouncementInformation1.vue"))
const AnnouncementPromo1 = async(() => import("@/Iris/Components/IrisBlocks/Announcement/AnnouncementPromo1Iris.vue"))
const AnnouncementPromo2Countdown = async(() => import("@/Iris/Components/IrisBlocks/Announcement/AnnouncementPromo2Countdown.vue"))
const AnnouncementInformation2TransitionText = async(() => import("@/Iris/Components/IrisBlocks/Announcement/AnnouncementInformation2TransitionText.vue"))
const AnnouncementPromo3 = async(() => import("@/Iris/Components/IrisBlocks/Announcement/AnnouncementPromo3.vue"))
const RenderDropshippingProduct = async(() => import("@/Iris/Components/IrisBlocks/Product/Ds/RenderDropshippingProductIris.vue"))
const RenderEcommerceProduct = async(() => import("@/Iris/Components/IrisBlocks/Product/Ecom/RenderEcommerceProductIris.vue"))
const RecommendationCRB1Iris = async(() => import("@/Iris/Components/IrisBlocks/RecommendationCRB1Iris.vue"))
const ProductIris2Ecom = async(() => import("@/Iris/Components/IrisBlocks/Product/Ecom/ProductIris2Ecom.vue"))
const ProductIris3Ecom = async(() => import("@/Iris/Components/IrisBlocks/Product/Ecom/ProductIris3Ecom.vue"))
const ProductIris4Ecom = async(() => import("@/Iris/Components/IrisBlocks/Product/Ecom/ProductIris4Ecom.vue"))
const AnnouncementInformational1 = async(() => import("@/Iris/Components/IrisBlocks/Announcement/AnnouncementInformational1Iris.vue"))
const Products2Render = async(() => import("@/Iris/Components/IrisBlocks/Products/Ecom/ProductCard/ProductCardEcom2.vue"))
const SeeAlso1Iris = async(() => import("@/Iris/Components/IrisBlocks/SeeAlso1Iris.vue"))
const family1Iris = async(() => import("@/Iris/Components/IrisBlocks/family1Iris.vue"))
const family2Iris = async(() => import("@/Iris/Components/IrisBlocks/family2Iris.vue"))
const family3Iris = async(() => import("@/Iris/Components/IrisBlocks/family3Iris.vue"))

const FamiliesIris1 = async(() => import("@/Iris/Components/IrisBlocks/FamiliesIris1.vue"))
const FamiliesIris2 = async(() => import("@/Iris/Components/IrisBlocks/FamiliesIris2.vue"))
const FamiliesIris3 = async(() => import("@/Iris/Components/IrisBlocks/FamiliesIris3.vue"))
const FamiliesIris4 = async(() => import("@/Iris/Components/IrisBlocks/FamiliesIris4.vue"))

const SubDepartment1Iris = async(() => import("@/Iris/Components/IrisBlocks/SubDepartmentsIris.vue"))
const SubDepartment2Iris = async(() => import("@/Iris/Components/IrisBlocks/SubDepartmentsIris2.vue"))
const SubDepartment3Iris = async(() => import("@/Iris/Components/IrisBlocks/SubDepartmentsIris3.vue"))
const SubDepartment4Iris = async(() => import("@/Iris/Components/IrisBlocks/SubDepartmentsIris4.vue"))

const WowsbarBannerIris = async(() => import("@/Iris/Components/IrisBlocks/WowsbarBannerIris.vue"))
const ImageIris = async(() => import("@/Iris/Components/IrisBlocks/ImageIris.vue"))
const TextContentIris = async(() => import("@/Iris/Components/IrisBlocks/TextContentIris.vue"))
const CtaImageBackroundIris = async(() => import("@/Iris/Components/IrisBlocks/CtaImageBackroundIris.vue"))
const BentoGridIris = async(() => import("@/Iris/Components/IrisBlocks/BentoGridIris.vue"))
const GalleryIris = async(() => import("@/Iris/Components/IrisBlocks/GalleryIris.vue"))
const Cta1Iris = async(() => import("@/Iris/Components/IrisBlocks/Cta1Iris.vue"))
const Cta2Iris = async(() => import("@/Iris/Components/IrisBlocks/Cta2Iris.vue"))
const Cta3Iris = async(() => import("@/Iris/Components/IrisBlocks/Cta3Iris.vue"))
const IframeIris = async(() => import("@/Iris/Components/IrisBlocks/IframeIris.vue"))
const OverviewIris = async(() => import("@/Iris/Components/IrisBlocks/OverviewIris.vue"))
const Overview2Iris = async(() => import("@/Iris/Components/IrisBlocks/Overview2Iris.vue"))
const ScriptIris = async(() => import("@/Iris/Components/IrisBlocks/ScriptIris.vue"))
const CtaAurora1Iris = async(() => import("@/Iris/Components/IrisBlocks/CtaAurora1Iris.vue"))
const TextColumnIris = async(() => import("@/Iris/Components/IrisBlocks/TextColumnIris.vue"))
const PricingIris = async(() => import("@/Iris/Components/IrisBlocks/PricingIris.vue"))
const ButtonIris = async(() => import("@/Iris/Components/IrisBlocks/ButtonIris.vue"))
const ColumnIris = async(() => import("@/Iris/Components/IrisBlocks/ColumnIris.vue"))
const Column3Iris = async(() => import("@/Iris/Components/IrisBlocks/Column3Iris.vue"))
const Column4Iris = async(() => import("@/Iris/Components/IrisBlocks/Column4Iris.vue"))
const DisclosureIris = async(() => import("@/Iris/Components/IrisBlocks/DisclosureIris.vue"))
const TimelineIris = async(() => import("@/Iris/Components/IrisBlocks/TimelineIris.vue"))

const Carousel1Iris = async(() => import("@/Iris/Components/IrisBlocks/Carousel1Iris.vue"))
const CarouselCtaIris = async(() => import("@/Iris/Components/IrisBlocks/CarouselCtaIris.vue"))
const CarouselImageBackgroundIris = async(() => import("@/Iris/Components/IrisBlocks/CarouselImageBackgroundIris.vue"))
const CtaVideo1Iris = async(() => import("@/Iris/Components/IrisBlocks/CtaVideo1Iris.vue"))
const Video1Iris = async(() => import("@/Iris/Components/IrisBlocks/Video1Iris.vue"))
const UserSubscribeIris = async(() => import("@/Iris/Components/IrisBlocks/UserSubscribeIris.vue"))
const Appointment1Iris = async(() => import("@/Iris/Components/IrisBlocks/Appointment1Iris.vue"))
const LoginIris = async(() => import("@/Iris/Components/IrisBlocks/LoginIris.vue"))
const RegisterIris = async(() => import("@/Iris/Components/IrisBlocks/RegisterIris.vue"))
const RegisterDashboardIris = async(() => import("@/Iris/Components/IrisBlocks/RegisterDashboardIris.vue"))
const RegisterDashboard2Iris = async(() => import("@/Iris/Components/IrisBlocks/RegisterDashboard2Iris.vue"))
const ForgetPasswordIris = async(() => import("@/Iris/Components/IrisBlocks/ForgetPasswordIris.vue"))
const Cta4Iris = async(() => import("@/Iris/Components/IrisBlocks/Cta4Iris.vue"))
const BlogIris = async(() => import("@/Iris/Components/IrisBlocks/BlogIris.vue"))
const Step2Iris = async(() => import("@/Iris/Components/IrisBlocks/Step2Iris.vue"))
const Step1Iris = async(() => import("@/Iris/Components/IrisBlocks/Step1Iris.vue"))
const Slider1Iris = async(() => import("@/Iris/Components/IrisBlocks/Slider1Iris.vue"))
const CollectionDescriptionIris = async(() => import("@/Iris/Components/IrisBlocks/CollectionDescriptionIris.vue"))
const ProductRenderEcom3 = async(() => import("@/Iris/Components/IrisBlocks/Products/Ecom/ProductCard/ProductCardEcom3.vue"))
const Family2ExtraDescriptionIris = async(() => import("@/Iris/Components/IrisBlocks/Family2ExtraDescriptionIris.vue"))
const Families1Overview = async(() => import("@/Iris/Components/IrisBlocks/FamiliesOverviewIris1.vue"))
const RecommendationFromMasterIris = async(() => import("@/Iris/Components/IrisBlocks/RecommendationFromMasterIris.vue"))
const RealatedProductCategoryIris = async(() => import("@/Iris/Components/IrisBlocks/RealatedProductCategoryIris.vue"))
const RelatedProductcategoryFormMaster = async(() => import("@/Iris/Components/IrisBlocks/RecommendationProductCategoryFromMasterIris.vue"))
const TabsIris = async(() => import("@/Iris/Components/IrisBlocks/TabsIris.vue"))
const FaqDepartment = async(() => import("@/Iris/Components/IrisBlocks/FaqDepartment.vue"))
const TopFamiliesIris = async(() => import("@/Iris/Components/IrisBlocks/TopFamiliesIris.vue"))
const BlogListIris = async(() => import("@/Iris/Components/IrisBlocks/BlogListIris.vue"))
const BlogCategoriesIris = async(() => import("@/Iris/Components/IrisBlocks/BlogCategoriesIris.vue"))
const CategoryComparisonIris = async(() => import("@/Iris/Components/IrisBlocks/CategoryComparisonIris.vue"))

const components = (shop_type?: string): Record<string, Component> => {


	return {
		//topBar
		"top-bar-1": Topbar1Iris,
		"top-bar-2": Topbar2Iris,

		"top-bar-1-fulfilment": Topbar1FulfilmentIris,
		"top-bar-2-fulfilment": Topbar2Iris,

		//header
		"header-1": Header1Iris,
		"header-2": Header2Iris,


		//menu
		"menu-1": Menu1Iris,

		//footer
		"footer-1": Footer1Iris,

		 //description catalogue
		'collection-description-1' : CollectionDescriptionIris,
		'department-description-1' : DepartmentDescriptionIris,
		'department-description-2' : DepartmentDescriptionIris2,
		'department-description-3' : DepartmentDescriptionIris3,
		'sub-department-description-1' : SubDepartmentDescriptionIris,

		//sub-department
		"sub-departments-1": SubDepartment1Iris,
		"sub-departments-2": SubDepartment2Iris,
		"sub-departments-3": SubDepartment3Iris,
		"sub-departments-4": SubDepartment4Iris,

		//family
		"families-1": FamiliesIris1,
		"families-2": FamiliesIris2,
		"families-3": FamiliesIris3,
		"families-4": FamiliesIris4,


		//family
		"families-1-overview": Families1Overview,

		// family-description
		'family-1': family1Iris,
		'family-2': family2Iris,
		'family-3': family3Iris,

		 //family-extra-description
		'family-2-extra-description' : Family2ExtraDescriptionIris,
		'family-3-extra-description' : Family2ExtraDescriptionIris,

		//product
		"product-1": shop_type === "b2b" ? RenderEcommerceProduct : RenderDropshippingProduct,
		"product-2": RenderEcommerceProduct,
		"product-3": RenderEcommerceProduct,
		"product-4": RenderEcommerceProduct,

		//product list
		"products-1": shop_type === "b2b" ? ListProductsEcomIris : ListProductsIris,
		"products-2": ListProductsEcomIris,

		//see-also
		"see-also-1": SeeAlso1Iris,

		"luigi-trends-1": InternalTrends1Iris,
		"luigi-last-seen-1": InternalLastSeen1Iris,
		"luigi-item-alternatives-1": InternalItemAlternatives1Iris,
		"recommendation-customer-recently-bought-1": RecommendationCRB1Iris,

		"cta-image-background": CtaImageBackroundIris,
		banner: WowsbarBannerIris,
		"bento-grid-1": BentoGridIris,
		bricks: GalleryIris,
		cta1: Cta1Iris,
		cta2: Cta2Iris,
		cta3: Cta3Iris,
		iframe: IframeIris,
		images: ImageIris,
		overview_aurora: OverviewIris,
		overview_2: Overview2Iris,
		script: ScriptIris,
		text: TextContentIris,
		cta_aurora_1: CtaAurora1Iris,
		"text-column": TextColumnIris,
		pricing: PricingIris,
		button: ButtonIris,
		"column-layout-2": ColumnIris,
		"column-layout-3": Column3Iris,
		"column-layout-4": Column4Iris,
		disclosure: DisclosureIris,
		timeline: TimelineIris,

		"carousel-1": Carousel1Iris,
		"carousel-cta": CarouselCtaIris,
		"carousel-image-background": CarouselImageBackgroundIris,
		"step-1": Step1Iris,
		"cta-video-1": CtaVideo1Iris,
		video_1: Video1Iris,
		"user-subscribe": UserSubscribeIris,
		"appointment-1": Appointment1Iris,
		login: LoginIris,
		register: RegisterIris,
		"register-dashboard": RegisterDashboardIris,
		"register-dashboard-2": RegisterDashboard2Iris,
		"forgot-password": ForgetPasswordIris,
		cta4: Cta4Iris,
		blog: BlogIris,
		"step-2": Step2Iris,
		'video-1': Video1Iris,
		'slider-1' : Slider1Iris,
		'recommendation-from-master' : RecommendationFromMasterIris,
	    'relatedProductCategory' : RealatedProductCategoryIris,
		'recommendation-product-category-from-master' : RelatedProductcategoryFormMaster,
		'tabs' : TabsIris,
		'faq-department' : FaqDepartment,
		'top-families' : TopFamiliesIris,
		'blog-list' : BlogListIris,
		'blog-categories' : BlogCategoriesIris,
		'category-comparison' : CategoryComparisonIris
	}
}

export const getIrisComponent = (
	componentName: string,
	options?: {
		shop_type?: string // 'b2b' | 'dropshipping'
	}
) => {
	return components(options?.shop_type)[componentName] ?? NotFoundComponent
}

const preloadAsyncComponent = (component: any): Promise<unknown> | null =>
	component?.__asyncResolved || typeof component?.__asyncLoader !== "function" ? null : component.__asyncLoader().catch(() => null)

export const preloadIrisBlocks = (webBlocks: any, shopType?: string): Promise<unknown> =>
	Promise.all(
		(Array.isArray(webBlocks) ? webBlocks : Object.values(webBlocks ?? {})).map((webBlock: any) =>
			preloadAsyncComponent(getIrisComponent(webBlock?.type, { shop_type: shopType }))
		)
	)

export const preloadIrisPage = (pageProps: any): Promise<unknown> =>
	Promise.all([
		preloadIrisBlocks(pageProps?.web_blocks, pageProps?.retina?.type),
		...(pageProps?.announcements ?? []).map((announcement: any) =>
			preloadAsyncComponent(getIrisAnnouncementComponent(announcement?.template_code))
		),
	])

export const getProductsRenderDropshippingComponent = (
	componentName: string,
	options: Record<string, any> = {}
) => {
	const components: Record<string, any> = {
		"products-1": ProductRender,
	}

	return components[componentName] ?? null
}

export const getProductsRenderB2bComponent = (
	componentName: string,
	options: Record<string, any> = {}
) => {
	const components: Record<string, any> = {
		//"products-1": ProductRenderEcom, old
		"products-1": ProductRenderEcom3,
		"products-2": Products2Render,
	}

	return components[componentName] ?? null
}

export const getProductRenderB2bComponent = (
	componentName: string,
	options: Record<string, any> = {}
) => {
	const components: Record<string, any> = {
		"product-1": ProductIris1Ecom,
		"product-2": ProductIris2Ecom,
		"product-3": ProductIris3Ecom,
		"product-4": ProductIris4Ecom,
	}

	return components[componentName] ?? null
}


export const getProductRenderDropshippingComponent = (
	componentName: string,
	options: Record<string, any> = {}
) => {
	const components: Record<string, any> = {
		"product-1": ProductIris1,
	}

	return components[componentName] ?? null
}


export const announcementComponent = (shop_type?: string): Record<string, Component> => {
    return {
        'announcement-information-1': AnnouncementInformation1,
        'announcement-informational-1': AnnouncementInformational1,
        'announcement-promo-1': AnnouncementPromo1,
        'announcement-promo-3': AnnouncementPromo3,
        'announcement-promo-2-countdown': AnnouncementPromo2Countdown,
        'announcement-information-2-transition-text': AnnouncementInformation2TransitionText,

    }
}


export const getIrisAnnouncementComponent = (
	componentName: string,
	options?: {
		shop_type?: string // 'b2b' | 'dropshipping'
	}
) => {
	return announcementComponent(options?.shop_type)[componentName] ?? NotFoundComponent
}
